import { useEffect, useState } from 'react';

export interface ErrorPopupProps {
  message: string;
  onClose: () => void;
  /** Auto close duration in ms, default 5000. Pass 0 to disable auto close. */
  duration?: number;
}

export default function ErrorPopup({ message, onClose, duration = 5000 }: ErrorPopupProps) {
  const [visible, setVisible] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  const dismiss = () => {
    setIsClosing(true);
    window.setTimeout(() => {
      setVisible(false);
      onClose();
    }, 300);
  };

  useEffect(() => {
    if (!duration || duration <= 0) return;
    const timer = setTimeout(() => dismiss(), duration);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) return null;

  return (
    <div className={`error-popup ${isClosing ? 'closing' : ''}`}>
      <div className="error-popup-content">
        <span className="error-popup-icon" aria-hidden>!</span>
        <span className="error-popup-text" title={message}>{message}</span>
        <button
          type="button"
          className="error-popup-close"
          onClick={dismiss}
          aria-label="Đóng thông báo lỗi"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
